import React from "react";
import { useSelector, useDispatch } from "react-redux";
import ListPagination from "../../../../../../components/Tables/Pagination/ListPagination";
import {
  selectCurrentPage,
  selectTotalPages,
  setCurrentPage,
  selectRowsPerPage,
  setRowsPerPage,
} from "../../../../../../redux/customers/customerPaginationSlice";

const PaginationContainer = () => {
  const dispatch = useDispatch();
  const currentPage = useSelector(selectCurrentPage);
  const totalPages = useSelector(selectTotalPages);
  const rowsPerPage = useSelector(selectRowsPerPage);

  const handleRowsPerPageChange = (newRowsPerPage) => {
    dispatch(setRowsPerPage(newRowsPerPage));
    dispatch(setCurrentPage(1)); // Reset to first page when rows per page changes
  };

  const handlePageChange = (event, newPage) => {
    dispatch(setCurrentPage(newPage));
  };

  return (
    <ListPagination
      currentPage={currentPage}
      totalPages={totalPages}
      onPageChange={handlePageChange}
      rowsPerPage={rowsPerPage}
      setRowsPerPage={handleRowsPerPageChange}
    />
  );
};

export default PaginationContainer;
